<template>
  <div id="ucenter" >
    <div style="width: 100%; height: 15px;" ></div>
    <div class="head" >
      <div class="avatar" >
        <img v-if="!userInfo.profile" src="@/assets/images/Mensingles.png" alt="">
        <img v-if="userInfo.profile" :src="profileImg" @click="imagePreview = true" >
      </div>
      <div class="info" >
        <div class="exchange" >
          <span class="name" >{{userInfo.trueName}}</span>
          <div class="exchange-type" >
            <i class="name-icon" >{{activeMember.name}}</i>
            <div style="width: 100%; height: 4px;" v-if="secondMember" ></div>
            <van-icon v-if="secondMember" class="name-icon" name="exchange" @click="changeMemberType" />
            <div style="width: 100%; height: 4px;" v-if="!secondMember && applyMember.length>0" ></div>
            <span class="name-icon name-icon-add" v-if="!secondMember && applyMember.length>0" @click="addMemberType">
              <van-icon size="16px" name="add-o" @click="addMemberType" />
              <span>{{applyMember[0].name}}</span>
            </span>
          </div>
        </div>
        <div v-if="false">有效期 ({{vipRange.begin}} ～ {{vipRange.end}}) </div>
      </div>
    </div>
    <van-cell-group>
      <van-cell v-if="activeMember.type === 'player' || activeMember.type === 'coach'" title="所属会员单位" :value="memberInfo.organization && memberInfo.organization.name" />
    </van-cell-group>

    <van-cell-group v-if="activeMember.type === 'member'">
      <!-- to="show-player" -->
      <van-cell title="旗下运动员" is-link @click="goOrgPage('player')" />
      <van-cell title="旗下教练员" is-link @click="goOrgPage('coach')" />
      <!-- to="team-manmagement" -->
      <van-cell title="参赛管理" is-link to="team-manage?type=signUp" />
      <van-cell title="赛事报名" to="match-list?type=signUp" is-link />
    </van-cell-group>

    <van-cell title="基本信息" is-link @click="goMemberDetails(1)"/>

    <van-cell v-if="activeMember.type === 'player'" title="冰球水平" is-link @click="goMemberDetails(2)" />

    <van-cell-group v-if="activeMember.type === 'coach'">
      <van-cell title="个人经历" is-link @click="goMemberDetails(2)"/>
      <van-cell title="执教经历" is-link @click="goMemberDetails(3)"/>
    </van-cell-group>

    <van-cell-group v-if="activeMember.type === 'in-referee' || activeMember.type === 'out-referee' ">
      <van-cell title="个人经历" is-link @click="goMemberDetails(2)"/>
    </van-cell-group>

    <van-cell-group>
      <van-cell title="联系方式" v-if="activeMember.type !== 'member'" is-link @click="goMemberDetails(4)" />
      <van-cell title="运动员数据统计" is-link v-if="activeMember.type === 'player'" to="player-career" />
      <van-cell title="密码设置" is-link to="change-password" />
      <van-cell title="绑定手机" is-link to="replace-phone" />
      <!--<van-cell v-if="secondMember" title="身份切换" is-link @click="changeMemberType" />-->
      <van-cell title="成绩榜单" is-link to="match-list?type=grade"/>
      <van-cell title="查看保单" is-link @click="getInsureOrder" />
      <van-cell title="协会官网" is-link url="http://www.bjhockey.org" />
    </van-cell-group>

    <van-button class="btn" size="large" type="danger" @click="logOut">退出</van-button>

    <van-popup v-model="isShowPopup" position="bottom" :overlay="true">
      <van-picker show-toolbar :columns="columns" @cancel="onCancel" @confirm="onConfirm" ></van-picker>
    </van-popup>
    <van-image-preview
      v-model="imagePreview"
      :images="imagePreviewMap"
    >
    </van-image-preview>

    <div class="page-loading" v-if="isLoading">
      <van-loading size="32px"></van-loading>
      <div style="font-size: 14px; color: rgb(201, 201, 201);">加载中...</div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import { checkPassport } from '@/libs/passport'
import { getValidMembership, mapMemberType, ImageFormat } from '@/utils'
import { getUserInfo, setMemberType, getMemberType, removeMembership, removeUserInfo,
  removeRegisterInfo, removeToken, setMembership, removeMemberType } from '@/libs/cookie-storage'
import { getMyMembershipStatus, updateMembershipStatus, getMyPlayer, getMyCoach, getMyReferee,
  getMyOrganization, getInsuranceOrder } from '@/api/info'
import { getUserDetails, logOut } from '@/api/user'

import {Cell, CellGroup, Toast, Icon, ImagePreview, Loading} from 'vant'

Vue.use(Cell).use(CellGroup).use(Icon).use(ImagePreview).use(Loading)

export default {
  name: 'Ucenter',
  data() {
    return {
      currentMember: null,
      secondMember: null,
      activeMember: {},
      vipRange: {},
      userInfo: {},
      memberInfo: {},
      applyMember: [],
      columns: ['场内裁判员', '场外裁判员'],
      validMemberShip: '',
      isShowPopup: false,
      imagePreview: false,
      imagePreviewMap: [],
      isLoading: false,
      insurance: null
    }
  },
  computed: {
    profileImg() {
      let img = ImageFormat.squareImageView(this.userInfo.profile, 140, 2)
      this.imagePreviewMap.push(img)
      return img
    }
  },
  created () {
    checkPassport()
    removeRegisterInfo()
    getMyMembershipStatus().then((response) => {
      if (!response) return
      const validMemberShip = this.validMemberShip = getValidMembership(response.data)
      setMembership(response.data)
      this.vipRange = {
        begin: moment(validMemberShip.membershipBeginDate).format('YYYY-MM-DD'),
        end: moment(validMemberShip.membershipEndDate).format('YYYY-MM-DD')
      }
      const membership = validMemberShip.membership
      if (membership.length === 0) {
        this.$router.push('evpi')
        return
      }
      // TODO pay status check
      let member = _.find(membership, function (item) {
        return (item.paymentStatus > 0) && (item.status > 0) // 付款通过 payStatus
      })

      if (member) { // 如果有一个身份付款，则进入个人中心
        let currentMember = mapMemberType(member.membershipTypeId)
        this.currentMember = _.assign(currentMember, member) // 字段合并
        if (this.currentMember.insurance && this.currentMember.insurance.PolicyNo) {
          this.insurance = this.currentMember.insurance
        }
        if (membership.length > 1) {
          let secMember = membership[1]
          if (member !== membership[0]) {
            secMember = membership[0]
          }
          let secondMember = mapMemberType(secMember.membershipTypeId)
          this.secondMember = _.assign(secondMember, secMember) // 字段合并
        }
        const memberType = getMemberType()
        if (memberType) {
          if (memberType.type === currentMember.type) {
            this.activeMember = currentMember
          } else if (this.secondMember && memberType.type === this.secondMember.type) {
            this.activeMember = this.secondMember
          } else {
            this.activeMember = currentMember
          }
        } else {
          this.activeMember = currentMember
        }

        // 获取会员所属单位
        this.getMyInfo()
        //
        if (currentMember.membershipTypeId === 1) { // 运动员
          if (this.validMemberShip.coachRegisterEnabled) {
            //this.applyMember.push(mapMemberType(2))
            if (this.validMemberShip.inRefereeRegisterEnabled) {
              this.applyMember.push(mapMemberType(3))
            }
            if (this.validMemberShip.outRefereeRegisterEnabled) {
              this.applyMember.push(mapMemberType(4))
            }
          }
        } else if (currentMember.membershipTypeId === 2) { // 教练员
          if (this.validMemberShip.inRefereeRegisterEnabled) {
            this.applyMember.push(mapMemberType(3))
          }
          if (this.validMemberShip.outRefereeRegisterEnabled) {
            this.applyMember.push(mapMemberType(4))
          }
        } else if (currentMember.membershipTypeId === 3 || currentMember.membershipTypeId === 4) { // 裁判
          if (this.validMemberShip.coachRegisterEnabled) {
            this.applyMember.push(mapMemberType(2))
          }
        }

      } else {
        this.$router.push('review')
      }
    })
  },
  mounted () {
    this.getUserInfo()
  },
  methods: {
    getUserInfo() {
      const userInfo = getUserInfo()
      const data = {
        id: userInfo.id
      }
      getUserDetails(data).then(res => {
        if (res) {
          const data = res.data
          this.userInfo = data.user
        }
      })
    },
    logOut() {
      logOut().then(res => {
        if (res) {
          const data = res.data
          if (data) {
            Toast('退出登录')
            removeMembership()
            removeUserInfo()
            removeToken()
            removeRegisterInfo()
            removeMemberType()
            this.$router.push('login')
          }
        }
      })
    },
    changeMemberType() {
      if (this.activeMember === this.currentMember) {
        this.activeMember = this.secondMember
      } else {
        this.activeMember = this.currentMember
      }
      if (this.activeMember.paymentStatus > 0) { // 付款通过，有权留在个人中心
//       this.getRegInfo()
      } else {
         this.$router.push('review')
      }
    },
    addMemberType() {
      if (this.applyMember.length === 1) {
        setMemberType(this.applyMember[0])
        this.$router.push('info')
      } else {
        this.isShowPopup = true
      }
    },
    getMyInfo() {
      if (this.activeMember.type === 'player') {
        this.getMyPlayer()
      } else if (this.activeMember.type === 'coach') {
        this.getMyCoach()
      } else if (this.activeMember.type === 'in-referee' || this.activeMember.type === 'out-referee') {
        this.getMyReferee()
      } else if (this.activeMember.type === 'member') {
        this.getMyOrganization()
      }
    },
    getMyPlayer() {
      getMyPlayer().then(response => {
        const data = response.data
        if (data) {
          this.memberInfo = data.player
        }
      })
    },
    getMyCoach() {
      getMyCoach().then(response => {
        const data = response.data
        if (data) {
          this.memberInfo = data.coach
        }
      })
    },
    getMyReferee() {
      getMyReferee().then(response => {
        const data = response.data
        if (data) {
          this.memberInfo = data.referee
        }
      })
    },
    getMyOrganization() {
      this.isLoading = true
      getMyOrganization().then(response => {
        const data = response.data
        if (data) {
          this.memberInfo = data.organization
        }
        this.isLoading = false
      })
    },
    goMemberDetails(step) {
      // type === member(会员单位的情况下联系方式没办法跳转)
      setMemberType(this.activeMember) // TODO 判断是否支付过，只能修改选填字段，09/01前修改俱乐部，拒绝后完善信息
      if (step === 1) {
        this.$router.push({ path: 'info', query: {isCenter: '1'} })
      } else if (step === 2 && this.activeMember.type === 'player') {
        this.$router.push('hockey')
      } else if (step === 2 && (this.activeMember.type === 'coach' || this.activeMember.type === 'in-referee' ||
        this.activeMember.type === 'out-referee')) {
        this.$router.push('personal-experience')
      } else if (step === 3 && this.activeMember.type === 'coach') {
        this.$router.push('coaching-experience')
      } else if (step === 4 && this.activeMember.type === 'player') {
        this.$router.push('contact-hockey')
      } else if (step === 4 && (this.activeMember.type === 'coach' || this.activeMember.type === 'in-referee' ||
        this.activeMember.type === 'out-referee')) {
        this.$router.push('contact-information')
      } else if (step === 4 && this.activeMember.type === 'member') {
        this.$router.push('contact-hockey')
      }
    },
    goOrgPage(type) {
      if (!this.memberInfo.id) return
      if (type === 'player') {
        this.$router.push({ path: 'show-player', query: {orgId: this.memberInfo.id} })
      } else if (type === 'coach') {
        this.$router.push({ path: 'show-coach', query: {orgId: this.memberInfo.id} })
      }

    },
    onConfirm(value, index) {
      this.isShowPopup = false
      const addMember = mapMemberType(index+3)
      setMemberType(addMember)
      this.$router.push('info')
    },
    onCancel() {
      this.isShowPopup = false
    },
    getInsureOrder () {
      const params = {
        orderNo: this.insurance.OrderNo,
        pno: this.insurance.PolicyNo
      }
      getInsuranceOrder(params).then((res) => {
        const data = res.data
        if (data && data.url) {
          window.location.href = data.url
        }
      })
    },
    goTest() {
      Toast('尚未完成')
    }
  }
}
</script>
<style>
  #ucenter {
  }

  #ucenter .head {
    height: 70px;
    display: flex;
    padding: 15px ;
  }

  #ucenter .avatar {
    /*overflow: hidden;*/
    margin-right: 10px;
  }

  #ucenter .avatar, #ucenter .avatar img {
    height: 70px;
    width: 70px;
    border-radius: 50%;
  }

  #ucenter .info {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  #ucenter .info .exchange {
    font-size: 18px;
    color: #191919;
    height: 40px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  #ucenter .exchange-type {
    display: flex;
    flex-direction:column;
    height: 55px;
    justify-content: center;
  }

  #ucenter .exchange-type .van-icon-exchange {
    text-align: center;
  }

  #ucenter .exchange-type i {
    height: 18px;
    line-height: 18px;
  }

  #ucenter .info div:first-child+div {
    color: #818181;
    font-size: 14px;
  }

  #ucenter .name {
    max-width: calc(100% - 120px);
    font-size: 14px;
    color: #191919;
    margin-right: 10px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  /*#ucenter .info div:first-child i {
    font-style: normal;
    margin-left: 10px;
    border-radius:18px;
    border:1px solid rgba(24,84,148,1);
    font-size: 14px;
    color:rgba(24,84,148,1);
    padding: 5px 10px;
  }*/

  #ucenter .name-icon {
    font-style: normal;
    font-size: 12px;
    color:rgba(24,84,148,1);
    position: relative;
    right: 10px;
    border-radius:18px;
    border:1px solid rgba(24,84,148,1);
    padding: 3px 10px;
  }

  #ucenter .van-cell:not(:last-child)::after {
    border-bottom: none;
  }

  #ucenter .van-hairline--top-bottom::after {
    border-width: 0;
  }

  #ucenter .van-cell {
    font-size: 16px;
    padding: 20px 15px;
    border-bottom: 1px solid #F2F2F2;
  }

  #ucenter .btn {
    height:60px;
    background: #185494;
    border-radius:2px;
    border: none;
    margin-top: 105px;
    font-weight:400;
    color: white;
    font-size:20px;
  }

  #ucenter .name-icon-add {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-color: #E2E2E2;
  }

  #ucenter .name-icon-add .van-icon {
    padding-right: 3px;
  }

  .page-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform:translate(-50%,-50%);

  }

</style>



// WEBPACK FOOTER //
// src/pages/ucenter/index.vue